import * as React from 'react';
import Model from './personalinfotype-model';
import BasePicklist from '../base/base-picklist.component';

interface IProps { 
  type?: string;
  currentId?: number;  
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class PersonalinfotypePicklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }



  public render(): React.ReactNode {
    return (
      <BasePicklist endPointFilter={Model.endPointFilterList(this.props.type)} model={Model} currentId={this.props.currentId} onLoad={this.props.onLoad} disableBackButton/>
    );
  }
}
